import React from 'react';
import PropTypes from 'prop-types';

const Body = ({ actionType, item }) => {
  switch (actionType) {
  case 'allow':
  case 'disallow':
    return (
      <div className="text-center">
        Are you sure you want to
        {' '}
        {actionType}
        {' '}
        <b>{item?.method_name}</b>
        {' '}
        for all users?
      </div>
    );

  default:
    return null;
  }
};

Body.propTypes = {
  actionType: PropTypes.string,
  item: PropTypes.object,
};

export default Body;
